import i18n from '../../lang/index'
import util from '../../utils/util'
i18n.locale = util.getCookie("locale") || 'en';
const lightServerRouter = [{
  path: '/lightserver',
  component: () => import('@/pages/Index'),
  redirect: {
    name: 'lsIndex'
  },
  children: [{
      path: 'index',
      name:'lsIndex',
      component: () => import('@/pages/lightServer/Index'),
      redirect: {
        name: 'lightserver'
      },
      children: [
        {
          name: 'lightserver',
          path: 'list',
          meta: {
            tab: 'list',
            title: i18n.t('lightserver.title'),
          },
          component: () => import('@/pages/lightServer/InstancList'),
        },
        {
          name: 'storage',
          path: 'storage',
          meta: {
            tab: 'storage',
            title: i18n.t('lightserver.title'),
          },
          component: () => import('@/pages/lightServer/HardDiskList'),
        },
        {
          name: 'snapshots',
          path: 'snapshots',
          meta: {
            tab: 'snapshots',
            title: i18n.t('lightserver.title'),
          },
          component: () => import('@/pages/lightServer/SnapshotList'),
        },
      ]
    },
    {
      name: 'detail',
      path: 'detail',
      meta: {
        tab: '',
        title: i18n.t('lightserver.title'),
      },
      component: () => import('@/pages/lightServer/InstancDetail'),
    },
    {
      name: 'lightserver/reinstall',
      path: 'reinstall',
      meta: {
        tab: '',
        title: i18n.t('lightserver.title'),
      },
      component: () => import('@/pages/lightServer/Reinstall'),
    },
    {
      name: 'login',
      path: 'login',
      meta: {
        tab: '',
        title: i18n.t('lightserver.instance.pages.loginPage.header'),
      },
      component: () => import('@/pages/login/Login'),
    }
  ]
}]
export default lightServerRouter



// WEBPACK FOOTER //
// ./src/router/modules/lightServer.js